import React, {
  useState,
  useRef,
  useEffect,
  useCallback,
  useContext,
  useMemo,
} from 'react'
import { DesignContext } from '../../../contexts/DesignContext'
import { Form, Row, Col, Image } from 'react-bootstrap'
import Webcam from 'react-webcam'
import CustomButton from './Button'
import Label from './Label'

import objectPath from 'object-path'

const CustomImageWebcam = (props) => {
  const { uischema, config } = props
  const {
    isDynamic = false,
    dynamicName = '',
    dynamicIndex = 0,
    dynamicData = {},
    onUpdateFormData = () => {},
    isArray,
    arrayName,
  } = config

  const fieldKey = isArray
    ? `@${arrayName}.${uischema.key}`
    : isDynamic
    ? `${dynamicName}.${dynamicIndex}.${uischema.key}`
    : uischema.key
  const fieldName = isArray
    ? `@${arrayName}.${uischema.name}`
    : isDynamic
    ? `${dynamicName}.${dynamicIndex}.${uischema.name}`
    : uischema.name

  const designContext = useContext(DesignContext)
  const { jsonForm, setFormData, findUischemaIndex, elementAction } =
    designContext
  const isLocked = objectPath.get(elementAction, ['isLockedEdit'])
  let hasEnable = objectPath.has(elementAction, ['isEnable', uischema.key])
  let isEnable = objectPath.get(elementAction, ['isEnable', uischema.key])
  let isReadOnly = useMemo(() => {
    if (isLocked) return isLocked
    if (hasEnable) {
      return isEnable === false ? true : false
    }
    return uischema.readonly
  }, [isEnable, uischema.readonly])

  const [capture, setCapture] = useState('')
  const webcamRef = useRef(null)

  const undoCapture = () => {
    setCapture()
  }

  const saveCapture = async (imageSrc) => {
    let file = await createFile(imageSrc)
    console.log('saveCapture', file)
    let newFormData = jsonForm.formData
    newFormData[uischema.key] = [file]
    setFormData(newFormData)
  }

  const createFile = async (imageSrc) => {
    if (imageSrc) {
      const response = await fetch(imageSrc)
      const blob = await response.blob()
      const extension = blob.type.split('/').pop()
      let image = new File([blob], `image.${extension}`, {
        type: blob.type,
      })
      image = Object.assign(image, {
        path: `image.${extension}`,
      })
      return image
    }
    return {}
  }

  const twainCapture = useCallback(() => {
    if (webcamRef.current) {
      const imageSrc = webcamRef.current.getScreenshot()
      setCapture(imageSrc)
      saveCapture(imageSrc)
    }
  }, [webcamRef])

  const [inModal, setInModal] = useState(null)
  const [modal, setModal] = useState({})

  const checkModal = (buttonKey) => {
    let schema = jsonForm.schema
    let mapTag = schema.mapTag
    let mapKey = schema.mapKey[buttonKey].split('.')
    mapKey.pop()
    mapKey.shift()
    let modalKey = mapKey.filter((key) => mapTag[key] === 'modal')
    if (modalKey.length > 0) {
      let lastModalKey = modalKey.pop()
      let elements = jsonForm.uischema.elements
      let modalMapKey = jsonForm.schema.mapKey[lastModalKey]
      let indices = findUischemaIndex(elements, modalMapKey)
      let newElements = indices.reduce((o, i) => o.elements[i], { elements })
      setModal(newElements)
      setInModal(modalKey)
    } else {
      setModal({})
      setInModal(null)
    }
  }

  useEffect(() => {
    if (uischema.action) {
      checkModal(uischema.key)
    }
  }, [])

  return (
    <Form.Group className="mb-0" controlId={uischema.controlId}>
      <Row className="w-100 m-0">
        <Label {...props} uischema={uischema} />
        <Col sm={uischema.elementWidth}>
          {capture ? (
            <Image
              id={`${fieldKey}-image`}
              name={`${fieldName}-image`}
              rounded={uischema.rounded}
              roundedCircle={uischema.shape === 'circle' ? true : false}
              src={capture}
              width={uischema.width}
              height={uischema.height}
              style={{
                objectFit: uischema.objectFit ? uischema.objectFit : 'contain',
              }}
            />
          ) : (
            <div
              className="d-flex"
              style={{
                width: uischema.width,
                height: uischema.height,
              }}
            >
              {modal.isOpen || !inModal ? (
                <Webcam
                  id={`${fieldKey}-webcam`}
                  name={`${fieldName}-webcam`}
                  width={uischema.width}
                  audio={false}
                  ref={webcamRef}
                  screenshotFormat="image/jpeg"
                  videoConstraints={{ facingMode: 'user' }}
                />
              ) : (
                <div
                  className="d-flex bg-light"
                  style={{
                    width: '100%',
                    height: uischema.height,
                  }}
                ></div>
              )}
            </div>
          )}
        </Col>
      </Row>
      {!isReadOnly && (
        <Row className="p-1">
          <Col sm={uischema.button.undo.layoutWidth} className="mt-2">
            <CustomButton
              fieldKey={`${fieldKey}-undo`}
              fieldName={`${fieldName}-undo`}
              uischema={uischema.button.undo}
              onCustomClick={undoCapture}
              customClick={true}
            />
          </Col>
          <Col sm={uischema.button.capture.layoutWidth} className="mt-2">
            <CustomButton
              fieldKey={`${fieldKey}-capture`}
              fieldName={`${fieldName}-capture`}
              uischema={uischema.button.capture}
              onCustomClick={twainCapture}
              customClick={true}
            />
          </Col>
        </Row>
      )}
    </Form.Group>
  )
}
export default CustomImageWebcam
